const index = () => import('@/views/main/index/index.vue')
export default {
  path: '/main/index',
  name: 'index',
  component: index,
  children: []
}
